import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/scenes/{id}/reset-thumbnail', 'post'>;

type Params = {
  sceneId: number;
};

export const resetSceneThumbnailFactory = (apiClient: ApiClient) => {
  const resetSceneThumbnail = async (sceneId: number): Promise<void> => {
    const requestParams = mapInputToRequestParams({ sceneId });
    await apiClient['/api/scenes/{id}/reset-thumbnail'].post(requestParams);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      params: {
        id: input.sceneId,
      },
    };
  };

  return resetSceneThumbnail;
};
